import { type TimeInterval, timeMonth, timeYear } from 'd3';

/**
 * Returns a d3 time interval for X-axis ticks based on available chart width.
 *
 * The goal is to avoid overlapping tick labels by reducing temporal density
 * on smaller screens while keeping semantic time steps.
 *
 * - < 500px  → yearly ticks
 * - < 800px  → quarterly ticks (every 3 months)
 * - ≥ 800px  → monthly ticks
 */
export const getTimeTickInterval = (width: number): TimeInterval => {
  const interval =
    width < 500 ? timeYear.every(1) : width < 800 ? timeMonth.every(3) /* quarter */ : timeMonth.every(1);

  // biome-ignore lint/style/noNonNullAssertion: d3's every() only returns null for non-positive steps; our literal steps (1, 3) are always valid
  return interval!;
};
